import { Injectable } from "@angular/core";
import { IHealthCheck } from "@ramudden/models/health-check";
import { Observable } from "rxjs";
import { ApiServiceBase } from "./api";

@Injectable({
    providedIn: "root",
})
export class MetaApi extends ApiServiceBase {
    override getRoute(): string {
        return "Meta";
    }

    version$(useCache = true): Observable<{ version: string }> {
        const url = `${this.getUrl()}/Version`;

        if (useCache) {
            return this.handleCaching(url);
        }

        return this.http.get<{ version: string }>(url);
    }

    getHealthCheck$(): Observable<IHealthCheck> {
        const url = `${this.getUrl()}/HealthCheck`;

        return this.http.get<IHealthCheck>(url);
    }
}
